export enum VerificationStatus {
  Approved = 1,
  Requested = 2,
  Rejected = 3,
  Processing = 4,
  UserRequested = 5,
  PendingRequest = 6,
}
